import React from 'react';
import cx from 'classnames';
import { DealDetails } from 'src/types/dealInsights';
import styles from './styles.module.scss';
import moment from 'moment';
import Text from 'src/components/text';
import TimeAgo from 'react-timeago';
import { round } from 'lodash';

interface Props {
  deal: DealDetails;
  isLoading: boolean;
  portalId: string | null;
}

const DefaultUserAvatar = '/images/default_user_profile_background.png';

const DealHeaderPlaceholder = () => {
  return( <div className={styles.placeholder}>
   <div className={styles.containerPlaceholder}>
      <span className={cx(styles.block, styles.title)} />
      <div className={styles.metricsRow}>
        <span className={cx(styles.block, styles.metric)} />
        <span className={cx(styles.block, styles.metric)} />
        <span className={cx(styles.block, styles.metric)} />
      </div>
      <div className={styles.pillsRow}>
        <span className={cx(styles.block, styles.pill)} />
        <span className={cx(styles.block, styles.pill)} />
        <span className={cx(styles.block, styles.pill)} />
        <span className={cx(styles.block, styles.pill)} />
      </div>
    </div>
 </div>
)};

export const DealHeader = ({ deal, isLoading, portalId  }: Props) => {
  const crmUrl =  portalId && deal?.externalId ? `https://app-na2.hubspot.com/contacts/${portalId}/record/0-3/${deal?.externalId}` : null;

  return (
    <div className={styles.headerContainer}>
      {isLoading ?
       <DealHeaderPlaceholder/>
        : <>
          <div className={styles.topRow}>
            <div className={styles.titleSection}>
              <p className={styles.dealTitle}>
                {deal?.dealName || ''}
              </p>
              <a href={crmUrl ?? ''}
                target="_blank"
                rel="noreferrer"
                className={styles.crmLink} > <i className='paperflite-redirect'></i> view in CRM </a>
            </div>

            {/* <div className={cx(styles.healthScore, deal.scoreTrend === 'up' ? styles.trendUp : styles.trendDown)}>
          <i className={deal.scoreTrend === 'up' ? "paperflite-trending" : "paperflite-arrow-down-right"} />
          <span className={styles.scoreValue}>{deal.score}</span>
          <span className={styles.scoreSign}>%</span>
        </div> */}
          </div>

          <div className={styles.metricsRow}>
            <div className={styles.metric}>
              <span className={styles.metricLabel}>Deal Value:</span>
              <span className={cx(styles.metricValue, styles.highlight)}>
                {deal.amount !== null && deal.amount !== undefined ? `$${round(deal.amount, 2)}` : '-'}
              </span>
            </div>
            <div className={styles.divider} />
            <div className={styles.metric}>
              <span className={styles.metricLabel}>Stage:</span>
              <span className={styles.metricValue}>{deal.stageLabel || '-'}</span>
            </div>
            <div className={styles.divider} />
            <div className={styles.metric}>
              <span className={styles.metricLabel}>Close Date:</span>
              <span className={styles.metricValue}>
                {deal.closeDate ? moment(deal.closeDate).format("DD MMM'YY") : '-'}
              </span>
            </div>
          </div>

          <div className={styles.metadataRow}>
            {deal.companyName && <div className={styles.pill}>
              <i className={cx('paperflite-industry', styles.pillIcon)} />
              <span className={styles.pillText}>Acc: {deal.companyName}</span>
            </div>}
            {deal.ownerName && <div className={styles.pill}>
              <img src={DefaultUserAvatar} alt="owner" className={styles.pillAvatar} />
              <span className={styles.pillText}>{deal.ownerName}</span>
            </div>}
            {deal.createDate && <div className={styles.pill}>
              <i className={cx("paperflite-calendar", styles.pillIcon)} />
              <span className={styles.pillText}>
                Created on: {moment(deal.createDate).format("DD MMM'YY")}
              </span>
            </div>}
            {deal.lastActivityDate && <div className={styles.pill}>
              <i className={cx("paperflite-clock", styles.pillIcon)} />
              <span className={styles.pillText}>
                 Last activity: <TimeAgo date={deal.lastActivityDate} live={false} />
              </span>
            </div>}
          </div>
        </> }
    </div>
  );
};

export default DealHeader;
